import React from 'react';

import {
  ContactSupportOutlined,
  ContactsOutlined,
  EventNoteOutlined,
  InsertInvitation,
  ListOutlined,
  LocalPoliceOutlined,
  ReceiptLongOutlined,
  SellOutlined,
} from '@mui/icons-material';
import StarOutlineIcon from '@mui/icons-material/StarOutline';
import { Box, SxProps } from '@mui/material';

import { HEADER_HEIGHT } from '~/components/layouts/Layout';

import SidebarSection, { SidebarSectionProps } from './SidebarSection';

interface Props {
  opportunityId: string;
}

const SIDEBAR_STYLE: SxProps = {
  borderColor: 'divider',
  position: { xs: 'static', md: 'sticky' },
  top: { md: 0 },
  alignSelf: { md: 'flex-start' },
  maxHeight: { md: `calc(100vh - ${HEADER_HEIGHT}px)` },
  overflowY: { md: 'auto' },
};

export default function OpportunitySidebar({ opportunityId }: Props) {
  if (!opportunityId) {
    return <Box sx={{ width: 280, p: 2 }}>Loading...</Box>;
  }

  const sections: Array<SidebarSectionProps> = [
    {
      title: 'Key info',
      items: [
        {
          label: 'Opportunity Info',
          icon: <StarOutlineIcon />,
          url: `/opportunity/${opportunityId}#opportunity-information`,
        },
        {
          label: 'Key contacts',
          icon: <ContactsOutlined />,
          url: `/opportunity/${opportunityId}#key-contacts`,
        },
        {
          label: 'Key commercial',
          icon: <SellOutlined />,
          url: `/opportunity/${opportunityId}#key-commercial`,
        },
      ],
    },
    {
      title: 'Deal details',
      items: [
        {
          label: 'Deal options',
          icon: <ListOutlined />,
          url: `/opportunity/${opportunityId}#deal-options`,
        },
        {
          label: 'Additional questions',
          icon: <ContactSupportOutlined />,
          url: `/opportunity/${opportunityId}#additional-questions`,
        },
        {
          label: 'Payments',
          icon: <ReceiptLongOutlined />,
          url: `/opportunity/${opportunityId}#payments`,
        },
      ],
    },
    {
      title: 'Dates & Policies',
      items: [
        {
          label: 'Deal dates',
          icon: <InsertInvitation />,
          url: `/opportunity/${opportunityId}#deal-dates`,
        },
        {
          label: 'Run dates',
          icon: <EventNoteOutlined />,
          url: `/opportunity/${opportunityId}#run-dates`,
        },
        {
          label: 'Policies',
          icon: <LocalPoliceOutlined />,
          url: `/opportunity/${opportunityId}#policies`,
        },
      ],
    },
  ];

  return (
    <Box sx={SIDEBAR_STYLE}>
      {sections.map((section, index) => (
        <SidebarSection key={`${section.title}-${index}`} {...section} />
      ))}
    </Box>
  );
}
